import { createClientGraphQLClient } from '../graphql/client/createClientGraphQLClient';
import type { RuntimeEnvironment } from '../graphql/config/runtimeConfig';
import { authStore } from './authStore';

export type AuthenticatedGraphQLClientOverrides = {
  env: RuntimeEnvironment;
  fetchImpl?: Parameters<typeof createClientGraphQLClient>[0]['fetchImpl'];
};

// Every authenticated (post-login) GraphQL client the app creates should attach the
// stored token and clear the session on a 401 — this is that policy applied once,
// so a future call site can't forget the onUnauthorized wiring the way the deleted
// ServerInfoProofPanel demo did.
export const createAuthenticatedGraphQLClient = (overrides: AuthenticatedGraphQLClientOverrides) =>
  createClientGraphQLClient({
    ...overrides,
    auth: { getAccessToken: () => authStore.getToken() },
    onUnauthorized: () => authStore.clearAuth(),
  });
